export default "__VITE_ASSET__a0dd3a04__"